module.exports = __webpack_public_path__ + "static/img/nuode-s.1824c94.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/nuode-s.png
// module id = 0rhQ
// module chunks = 1